interface Params {
    url: string;
    data: FormData;
}

export class SubmitMetaFormEvent extends CustomEvent<Params> {
    static type = 'submitMetaForm';

    constructor(params: Params) {
        super(SubmitMetaFormEvent.type, { bubbles: true, detail: params });
    }
}
